<template>
    <div class="paramsInputManagement">
      <router-view></router-view>
    </div>
</template>



<script>
export default {
  name: "paramsInputManagement",
  data() {
    return {};
  }
};
</script>
<style lang="stylus" scoped>
    
</style>
